module.exports = __webpack_public_path__ + "img/antonic-big-logo.d9ded030.svg";